import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Radio from '../../forms/Radio/Radio';

import styles from './styles.module.scss';
import {
  $cartState,
  handleSelectProduct,
  handleSelectFrequency,
} from '../../../store/models/cart';
import { useUnit } from 'effector-react';
import { useProductParams } from '../../../hooks/useProductParams';
import { $productsState } from '../../../store/models/products';
import { EProducts } from '../../../model/enums';

const OrderFrequency = () => {
  const { t } = useTranslation();
  const { grasses, catGrassSeeds } = useUnit($productsState);
  const { selectedProductSize, selectedProduct, selectedProductFrequency } = useUnit($cartState);
  const { productType, productSize } = useProductParams();

  const size = selectedProductSize || productSize;

  const [selectedCard, setSelectedCard] = useState<'subscribe' | 'oneTime'>('subscribe');

  // useEffect(() => {
  //   if(grasses) {
  //     const prod = grasses.find(pr => pr.size === size);
  //     // @ts-ignore
  //     handleSelectProduct(prod)
  //   }
  // }, [size, grasses])
  useEffect(() => {
    if (productType && productSize) {
      let selectedProduct = null;
      if (productType === EProducts.sds) {
        selectedProduct = catGrassSeeds.find((pr) => pr.size === size);
      } else if (productType === EProducts.grs) {
        selectedProduct = grasses.find((pr) => pr.size === size);
      }

      // @ts-ignore
      handleSelectProduct(selectedProduct);
    }
  }, [productType, productSize, grasses, catGrassSeeds]);

  useEffect(() => {
    handleSelectFrequency('two_week_price');
  }, []);

  function handleChangeFrequencyRadio(
    event: React.ChangeEvent<HTMLSelectElement>,
  ) {
    const { value } = event.target;

    handleSelectFrequency(value);
  }

  const frequencyCardData = [
    {
      value: 'subscribe',
      cardContent: (
        <div>
          <div className={styles.cardTitleWrapper}>
            <div className={styles.cardTitle}>{t('subscribeAndSave')} 5%</div>
            <div className={styles.priceWrapper}>
              <span className={styles.prevPrice}>
                €{selectedProduct?.price}
              </span>
              <span className={styles.currentPrice}>
                €{selectedProduct?.subscribe_price}
              </span>
            </div>
          </div>
          {selectedCard === 'subscribe' && (
            <div className={styles.cardContent}>
              <p>{t('chooseYourFrequency')}:</p>
              <select
                id="example-select"
                value={selectedProductFrequency || 'two_week_price'}
                onChange={handleChangeFrequencyRadio}
              >
                <option value="week_price">{t('weekly')}</option>
                <option value="two_week_price">
                  {t('every2Weeks')} ({t('popular')})
                </option>
                <option value="three_week_price">{t('every3Weeks')}</option>
                <option value="four_week_price">{t('every4Weeks')}</option>
              </select>
            </div>
          )}
        </div>
      ),
    },
    {
      value: 'oneTime',
      cardContent: (
        <div>
          <div className={styles.cardTitleWrapper}>
            <div className={styles.cardTitle}>{t('oneTimePurchase')}</div>
            <div className={styles.priceWrapper}>
              <span className={styles.currentPrice2}>
                €{selectedProduct?.price}
              </span>
            </div>
          </div>
          {selectedCard === 'oneTime' && (
            <div className={styles.cardContent}>
              {t('singleDeliveryProcessed')}
            </div>
          )}
        </div>
      ),
    },
  ];

  function handleChangeCard(event: React.ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;
    if (value === 'oneTime') {
      handleSelectFrequency('one_off_price');
    } else {
      handleSelectFrequency('two_week_price');
    }
    setSelectedCard(value as 'subscribe' | 'oneTime');
  }

  return (
    <div className={styles.orderFrequency}>
      <div className={styles.title}>{t('selectOrderFrequency')}</div>
      <div className={styles.radioGroup}>
        <Radio
          data={frequencyCardData}
          handleSelect={handleChangeCard}
          selectedOption={selectedCard}
        />
      </div>
    </div>
  );
};

export default OrderFrequency;
